<script>

import {t} from "../../core/i18n/language-store.js";

export let data;

</script>

<style>

</style>

{#if (data.visible)}
    <div class="dm-label">
        {$t('dmLabel.text')} <a href={ data.link } target="_blank">{ data.label }</a>
    </div>
{/if}
